import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { useViewShortfalls } from 'all-in-one-shared-api';

import { GenericResult, Spinner } from 'components';

import { SettleContent } from './SettleContent';
import { useKeycloakReady } from '../../../../hooks';

export const SettleAll = (): JSX.Element => {
  const { t } = useTranslation();
  const { keycloak, initialized } = useKeycloak();
  const [inited, setInited] = useState(false);
  const { token, tokenParsed } = useKeycloakReady();

  const { data, shouldFetch, isLoading, error } = useViewShortfalls({
    authToken: token || '',
    memberType: tokenParsed?.memberType,
  });

  useEffect(() => {
    shouldFetch(initialized && !!keycloak.authenticated && !!keycloak.token);

    if (!inited) setInited(true);
  }, [inited, initialized, keycloak.authenticated, keycloak.token, shouldFetch]);

  if (!inited || isLoading) {
    return <Spinner />;
  }

  if (error || (data && data.results.length === 0)) {
    return (
      <GenericResult
        status="error"
        title={t('claims.notFound.title')}
        defaultTo="/claims/shortfall"
        defaultLabel={t('claims.notFound.goBack')}
      />
    );
  }

  return data && data.results.length !== 0 ? (
    <SettleContent claims={data.results.filter((item) => item.shortfallFlag != 'Y')} />
  ) : (
    <Spinner />
  );
};
